export default __webpack_public_path__ + "static/media/ipredict_building.95ec28a8.jpg";